import styled from 'styled-components/macro'
import { Image } from '@chakra-ui/react'

export const StyledImage = styled(Image)`
  width: 110px;
  height: 130px;
  object-fit: cover;
  border-radius: 5px;
`

export const StyledBlogImage = styled(Image)`
  width: 100%;
  object-fit: cover;
  border-radius: 5px;
`
